import type { FC } from 'react';
import { Alert, Box, Button, FormHelperText, TextField } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import useMounted from '../../hooks/useMounted';
import * as Yup from 'yup';
import { Formik } from 'formik';

const LogOutJWT: FC = (props) => {
  const mounted = useMounted();
  const { logout } = useAuth() as any;

  const logOut = () => {
    // alert("Hello!")
    logout()
  };

  return (
    <Button
              color='primary'
              size='large'
              type='submit'
              variant='contained'
              onClick={logOut}
            > LogOut</Button>
  );
};



export default LogOutJWT;
